<template>
  <div class="kyano-card-profiles-toggle">
    <div class="kyano-card-profiles-toggle-kc-group">
      <v-switch
        class=""
        v-model="data.switch"
        inset
        color="secondary"
        :value="data.id"
      ></v-switch>
      <div class="kyano-card-profiles-toggle-kc-avatar d-none d-md-flex">
        <v-avatar>
          <v-img class="d-none d-md-flex" :src="data.avatar" />
        </v-avatar>
      </div>
      <div class="kyano-card-profiles-toggle-kc-content">
        <h3 class="font-weight-bold">
          {{ data.profile_firstname }} {{ data.profile_lastname }}
        </h3>
        <span v-html="data.function"></span> -
        <span v-html="data.companyname"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },

};
</script>

<style>
.kyano-card-profiles-toggle {
  display: block;
  position: relative;
  height: 100px;
  padding: 20px;
  max-width: 400px;
  clear: both;
  border-radius: 15px;
  border: 1px solid #d0d0d0;
  margin-bottom: 10px;
}

.kyano-card-profiles-toggle-kc-group {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

.kyano-card-profiles-toggle-kc-avatar {
  width: 60px;
  height: 60px;
  float: left;
  margin-bottom: 0px;
}
</style>
